<template>
  <v-select
    label="Type"
    :items="placementTypesList"
    v-model="placementTypeValue"
    item-text="label"
    item-value="id"
    outlined
    clearable
    :dense="dense"
  ></v-select>
</template>

<script>
import { placementTypes } from '@/lib/enum/placementTypes'

export default {
  props: [
    'placementTypeId',
    'dense'
  ],
  data () {
    return {
      placementTypesList: [
        { id: placementTypes.Deal, label: 'Deal' },
        { id: placementTypes.Assignment, label: 'Contract' },
        { id: placementTypes.DirectPlacement, label: 'Perm. Placement' }
      ]
    }
  },
  computed: {
    placementTypeValue: {
      get () {
        return this.placementTypeId
      },
      set (newValue) {
        this.$emit('placementTypeIdChangeHandler', newValue)
      }
    }
  }
}
</script>
